import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  NOTIFICATION_TYPE,
  NotificationGroup,
  NOTIFICATION_STATUS,
} from 'config/notification'
import { GET_ME_NOTIFICATION_GROUPS } from 'hooks/me/useMeNotificationGroups/GET_ME_NOTIFICATION_GROUPS'
import { useAuth } from 'providers/Auth'

export const useMeNotificationGroups = ({
  notificationType,
  notificationStatus,
}: {
  notificationType?: NOTIFICATION_TYPE
  notificationStatus?: NOTIFICATION_STATUS[]
}) => {
  const { isAuth } = useAuth()
  const result = useQuery<{
    me: {
      notificationGroups: NotificationGroup[]
    }
  }>(GET_ME_NOTIFICATION_GROUPS, {
    variables: { notificationType, filters: { status: notificationStatus } },
    skip: !isAuth,
  })

  return useMemo(
    () => ({
      ...result,
      notificationGroups: result?.data?.me?.notificationGroups,
    }),
    [result]
  )
}
